export enum LOCATION_ROLE {
  ORIGIN = 'OriginLocation', //Very first location on a route
  DESTINATION = 'DestinationLocation', //Very last location on a route
  PICKUP = 'PickupLocation', //Any pickup location on a route except very first one
  DELIVERY = 'DeliveryLocation', //Any delivery location on a route except very last one
  STOP = 'PlannedStopLocation', //Planned stop location on a route
  CORRECTION = 'RoadCorrectionLocation', //Road correction location on a route
  FULFILLMENT = 'FulfillmentLocation', //Location to which device or RMO client can be assigned
  VENUE = 'VenueLocation' //Location to which asset (tractor/trailer) can be assigned
}